module.exports = __webpack_public_path__ + "img/qr1.22c95bba.jpg";